/**
 * CORPAPI对应CORPAPI error
 * TagAPI,SyncAPI对应SyncAPI error
 */
const SERVER_ERROR = 'err_networkbusy' // 服务器暂时不可用，请稍后再试
const SYS_ERROR = 'export_server_busy' // 系统繁忙，请稍后再试

export default {
  CORPAPI: {
    '-1': SERVER_ERROR,
    0: SERVER_ERROR,
    1: SERVER_ERROR,
    2: SERVER_ERROR,
    3: SERVER_ERROR,
    100: SERVER_ERROR,
    101: SERVER_ERROR,
    102: 'err_invalidemail',
    103: 'err_repwdnotmatch',
    104: SERVER_ERROR,
    105: 'cc_sys_account_logout',
    106: 'cc_comm_invalidemail',
    107: 'err_smscode',
    109: 'err_nopermit',
    201: 'cc_sys_email_notregistered',
    202: 'err_emailused',
    203: 'lang_cc_sys_account_notactivated',
    204: 'email_already_active',
    205: 'cc_sys_account_disabled',
    206: 'lang_cc_comm_loginerror',
    207: SERVER_ERROR,
    208: 'err_repwdnotmatch',
    211: SERVER_ERROR,
    221: SERVER_ERROR,
    231: SERVER_ERROR,
    232: SERVER_ERROR,
    233: SERVER_ERROR,
    260: 'error_account',
    261: 'error_account',
    262: 'error_account',
    263: 'error_account',
    264: 'error_account',
    265: 'error_account',
    266: 'error_account',
    267: 'err_nopermit',
    268: 'err_invite_token_expire',
    269: 'err_lastadmin',
    270: 'err_invite_remove',
    271: 'err_nopermit',
    272: 'fast_track_exhausted',
    273: 'error_purhcase',
    274: 'error_purhcase_package',
    275: 'error_purhcase',
    276: 'err_nopermit',
    277: 'depart_exist',
    278: 'rules_not_right',
    280: 'error_account_belong',
    281: 'can_not_choose_own',
    282: 'err_superior_fail',
    283: 'error_superior_exist',
    287: 'err_nopermit',
    288: 'error_corpname_limit',
    289: 'error_username_limit',
    290: 'error_mlogin_limit',
    291: 'edm_out_limit_cantact_admin',
    292: 'err_invite_send_fail',
    293: SERVER_ERROR,
    295: 'excel_init_error_occupied',
    301: SERVER_ERROR,
    302: SERVER_ERROR,
    303: SERVER_ERROR,
    304: SERVER_ERROR,
    305: SERVER_ERROR,
    306: SERVER_ERROR,
    307: SERVER_ERROR,
    310: SERVER_ERROR,
    311: SERVER_ERROR,
    312: SERVER_ERROR,
    313: SERVER_ERROR,
    350: SERVER_ERROR,
    351: SERVER_ERROR,
    401: SERVER_ERROR,
    402: SERVER_ERROR,
    403: SERVER_ERROR,
    500: SERVER_ERROR,
    501: SERVER_ERROR,
    502: SERVER_ERROR,
    503: SERVER_ERROR,
    504: SERVER_ERROR,
    505: SERVER_ERROR
  },
  SyncAPI: {
    '-1': SERVER_ERROR,
    0: SERVER_ERROR,
    1: SERVER_ERROR,
    103: 'tagname_exist',
    105: 'err_nopermit',
    106: 'err_cannot_change_crm',
    109: 'err_nopermit',
    112: 'err_nopermit',
    113: 'task_deleted',
    120: 'search_result_notice2',
    304: 'err_fast_track',
    621: 'tagname_exist',
    622: 'has_deleted',
    1063: 'err_import_header',
    1061: 'err_import_size',
    1065: 'edm_upload_image_illegal_tip',
    1599: SYS_ERROR,
    1598: SYS_ERROR,
    1597: SYS_ERROR,
    1596: SYS_ERROR,
    1593: SYS_ERROR,
    1594: SYS_ERROR,
    1592: SYS_ERROR,
    1591: SYS_ERROR,
    1590: SYS_ERROR,
    1586: SYS_ERROR,
    1585: SYS_ERROR,
    1583: SYS_ERROR,
    1584: SYS_ERROR,
    1577: SYS_ERROR,
    1576: SYS_ERROR
  }
}
